import { makeStyles } from '@material-ui/core'
import { useState } from 'react'
import { COLORS } from 'src/utils/Themes/colors'
import rightArrow from 'src/assets/PolicyTile_Images/Polygon39.svg'

const KeyNotes = ({ keyNotesData }) => {
  const classes = useStyles()

  const [currentKeyNote, setCurrentKeyNote] = useState(
    keyNotesData?.length ? keyNotesData?.[0] : {}
  )
  const [currentKeyNoteIndex, setCurrentKeyNoteIndex] = useState(0)

  const handleRightClick = () => {
    setCurrentKeyNoteIndex(currentKeyNoteIndex + 1)
    setCurrentKeyNote(keyNotesData[currentKeyNoteIndex + 1])
  }
  const handleLeftClick = () => {
    setCurrentKeyNoteIndex(currentKeyNoteIndex - 1)
    setCurrentKeyNote(keyNotesData[currentKeyNoteIndex - 1])
  }

  const isLeftArrowDisabled = () => {
    return !keyNotesData?.length || currentKeyNoteIndex === 0
  }

  const isRightArrowDisabled = () => {
    return (
      !keyNotesData?.length || currentKeyNoteIndex + 1 === keyNotesData?.length
    )
  }

  return (
    <>
      <div className={classes.container}>
        <p className={classes.heading}>Key Notes</p>
        <div className={classes.keyPointsContainer}>
          <div
            id='leftArrow'
            className={`${classes.arrowContainer} ${
              isLeftArrowDisabled() ? classes.arrowContainerDisabled : null
            }`}
            onClick={isLeftArrowDisabled() ? null : handleLeftClick}
          >
            <img
              src={rightArrow}
              className={classes.leftArrow}
              alt='Left Arrow'
            />
          </div>

          <div className={classes.keyNoteContent}>
            {keyNotesData?.length ? (
              <>
                {currentKeyNote.heading && (
                  <p className={classes.title}>{currentKeyNote?.heading}</p>
                )}
                <span className={classes.content}>
                  {currentKeyNote?.content}
                </span>
              </>
            ) : (
              <span className={classes.noDataText}>No Key Notes Available</span>
            )}
          </div>

          <div
            id='rightArrow'
            className={`${classes.arrowContainer} ${
              isRightArrowDisabled() ? classes.arrowContainerDisabled : null
            }`}
            onClick={isRightArrowDisabled() ? null : handleRightClick}
          >
            <img src={rightArrow} alt='Right Arrow' />
          </div>
        </div>
      </div>
    </>
  )
}

export default KeyNotes

const useStyles = makeStyles({
  container: {
    padding: '10px 15px 15px 15px',
  },
  heading: {
    margin: '0px 0px 4px 0px',
    color: COLORS.DARK_PINK,
    fontWeight: 'bold',
    textAlign: 'initial',
  },
  keyPointsContainer: {
    height: '150px',
    border: '1px solid #BBBBBB',
    borderRadius: '10px',
    display: 'flex',
    justifyContent: 'space-between',
  },
  arrowContainer: {
    alignSelf: 'center',
    padding: '0px 15px',
    cursor: 'pointer',
    opacity: '1',
  },
  arrowContainerDisabled: {
    opacity: '0.1 !important',
  },
  leftArrow: {
    transform: 'rotate(180deg)',
  },
  keyNoteContent: {
    alignSelf: 'center',
    color: '#000000',
    height: 'inherit',
  },
  title: {
    fontSize: '16px',
    fontWeight: 'bold',
  },
  content: {
    fontSize: '12px',
    overflow: 'scroll',
    display: 'flex',
    height: '100%',
    justifyContent: 'center',
    alignItems: 'center',
  },
  noDataText: {
    color: 'rgba(0,0,0,.25)',
    textAlign: 'center !important',
    fontWeight: 'bold !important',
    display: 'flex',
    height: '100%',
    justifyContent: 'center',
    alignItems: 'center',
  },
})
